import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { diffTextInline, normalizeDiffValue } from '~/functions/object-diff';
import { renderMarkdown } from '~/functions/markdown';
export default /*#__PURE__*/_defineComponent({
  __name: 'DiffValue',
  props: {
    baseline: {
      type: [String, Number, Boolean, null]
    },
    current: {
      type: [String, Number, Boolean, null]
    },
    type: null
  },
  setup: function setup(__props) {
    var props = __props;
    var fieldType = computed(function () {
      var _props$type;
      return (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'text';
    });
    var normalizedBaseline = computed(function () {
      return normalizeDiffValue(props.baseline, fieldType.value);
    });
    var normalizedCurrent = computed(function () {
      return normalizeDiffValue(props.current, fieldType.value);
    });
    var showBaseline = computed(function () {
      return fieldType.value !== 'text' && normalizedBaseline.value.length > 0 && normalizedCurrent.value.length > 0;
    });
    var showInlineTextDiff = computed(function () {
      return fieldType.value === 'text' && normalizedBaseline.value.length > 0 && normalizedCurrent.value.length > 0;
    });
    var showCurrent = computed(function () {
      return !showInlineTextDiff.value && normalizedCurrent.value.length > 0;
    });
    var isAdded = computed(function () {
      return normalizedBaseline.value.length === 0 && normalizedCurrent.value.length > 0;
    });
    var isRemoved = computed(function () {
      return normalizedBaseline.value.length > 0 && normalizedCurrent.value.length === 0;
    });
    var baselineClass = computed(function () {
      return isRemoved.value ? 'ix-diff-value__removed' : 'ix-diff-value__old';
    });
    var currentClass = computed(function () {
      return isAdded.value ? 'ix-diff-value__added-only' : 'ix-diff-value__new';
    });
    function renderValue(value, mode) {
      if (fieldType.value === 'markdown') {
        return renderMarkdown(value);
      }
      return value;
    }
    var inlineTextDiffHtml = computed(function () {
      return diffTextInline(normalizedBaseline.value, normalizedCurrent.value);
    });
    var baselineHtml = computed(function () {
      if (!normalizedBaseline.value) return '';
      if (isRemoved.value) {
        return fieldType.value === 'markdown' ? renderMarkdown(normalizedBaseline.value) : normalizedBaseline.value;
      }
      return renderValue(normalizedBaseline.value, 'baseline');
    });
    var currentHtml = computed(function () {
      if (!normalizedCurrent.value) return '';
      return fieldType.value === 'markdown' ? renderMarkdown(normalizedCurrent.value) : normalizedCurrent.value;
    });
    return {
      __sfc: true,
      props: props,
      fieldType: fieldType,
      normalizedBaseline: normalizedBaseline,
      normalizedCurrent: normalizedCurrent,
      showBaseline: showBaseline,
      showInlineTextDiff: showInlineTextDiff,
      showCurrent: showCurrent,
      isAdded: isAdded,
      isRemoved: isRemoved,
      baselineClass: baselineClass,
      currentClass: currentClass,
      renderValue: renderValue,
      inlineTextDiffHtml: inlineTextDiffHtml,
      baselineHtml: baselineHtml,
      currentHtml: currentHtml
    };
  }
});